/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FloatMoreBrand.css';
import cx from 'classnames'
import history from '../../history'
import moment from 'moment'
import Model from '../Model'


class FloatMoreBrand extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      isShowModel:false
    }
    this.closeModel=this.closeModel.bind(this)
  }
  
  closeModel=()=>{
    this.setState({
      isShowModel:false
    })
    this.props.close()
  }

  render() {
    const  {isShowModel}=this.state
    
   
    return (
      <div className={this.props.show?s.root:s.hide}>
        <div className={s.model}>
          <div className={s.box} >
            <div className={s.flTxt} >
              <p className={s.flSpan}>想看更多品牌？</p>
              <p className={s.flSpan}>联系我们成为正式用户吧！</p>
              <div className={s.center}>
                <div className={s.showBtn} onClick={()=>{
                  this.setState({isShowModel:true})
                }}>成为正式用户</div>
              </div>
              <div className={s.showBtn} onClick={this.props.close}>取消</div>
            </div>
          </div>
          <Model isShow={isShowModel} close={this.closeModel} />
        </div>
      </div>
    )
  }
}

export default withStyles(s)(FloatMoreBrand);



// WEBPACK FOOTER //
// src/components/FloatMoreBrand/FloatMoreBrand.js